import { render, staticRenderFns } from "./InvoicesComponent.vue?vue&type=template&id=02e87daf&scoped=true&"
import script from "./InvoicesComponent.vue?vue&type=script&lang=js&"
export * from "./InvoicesComponent.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesComponent.vue?vue&type=style&index=0&id=02e87daf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e87daf",
  null
  
)

export default component.exports